<script>
import {alterarStatus} from '../../../../../domain/grv/services'
import {Status, StatusTitle} from '../../../../../domain/grv/helpers/GrvStatus'
import PopupViewerAlert from '../../../../_default/components/popup-viewer/PopupViewerAlert'

export default {
  name: 'BtnAlteraStatusGrv',
  components: {PopupViewerAlert},
  data () {
    return {
      newStatus: null,
      show: false,
      Status
    }
  },
  methods: {
    setNewStatus () {
      if (!confirm(`ATENÇÃO: Confirmar alteração do status desta GRV para "${this.StatusTitle(this.newStatus).toUpperCase()}"?`)) {
        this.show = false
        this.newStatus = null
        return
      }
      this.$loaderOverlay.open().message('Alterando status da GRV...')
      alterarStatus(this.$route.params.id, this.newStatus)
        .then(response => {
          this.show = false
          this.newStatus = null
          this.$emit('statusAlterado')
        })
        .catch(error => {
          alert('Houve um erro ao alterar o status da Grv')
          console.log(error.data)
          this.$loaderOverlay.hide()
        })
    },
    toggleShow () {
      this.show = !this.show
    },
    StatusTitle (s, t) {
      return StatusTitle(s, t)
    },
    cancelar () {
      this.newStatus = null
      this.show = false
    }
  }
}
</script>

<template>
<div>
  <div class="m-t-sm m-b-sm">
    <button class="btn btn-default font-bold btnlock" @click="toggleShow">{{show ? 'Cancelar' : 'Alterar status da GRV'}}</button>
  </div>
  <popup-viewer-alert v-if="show" title="Alteração manual de status da GRV">
    <div class="form-group m-t-sm">
      <select v-model="newStatus" class="form-control">
        <option :value="null" disabled>Selecione o novo status</option>
        <option v-for="(status, key) in Status" :value="key">{{status.titulo}}</option>
      </select>
    </div>
    <div style="display: flex; justify-content: end; align-items: center">
      <button class="btn btn-sm btn-default m-l" @click="cancelar">Cancelar</button>
      <button class="btn btn-sm btn-info m-l" @click="setNewStatus" :disabled="newStatus === null">Confirmar</button>
    </div>
  </popup-viewer-alert>
</div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// BtnAlteraStatusGrv.vue?653f3378